import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { APP_CONSTANT, AppConst } from 'src/app/core/_constants/app.constant';
import { ValidationService } from 'src/app/core/_services/common/validation.service';
import { PagesService } from 'src/app/core/_services/pages/pages.service';
import { ChoosePaymentComponent } from '../choose-payment/choose-payment.component';
import { ConfirmDialogComponent } from '../confirm-dialog.component';
import { OnlinePaymentComponent } from '../online-payment/online-payment.component';
import { PaymentCompletedComponent } from '../payment-completed/payment-completed.component';
import { MatSelect } from '@angular/material/select';
import { ComingSoonDialogComponent } from '../../coming-soon-dialog/coming-soon-dialog.component';
import { LocalStorageProvider } from 'src/app/core/_services/common/storage.service';

@Component({
  selector: 'app-add-subscription',
  templateUrl: './add-subscription.component.html',
  styleUrls: ['./add-subscription.component.scss']
})
export class AddSubscriptionComponent implements OnInit, AfterViewInit {

  updateClientForm: FormGroup;
  submitted: boolean = false;
  validationErrorMessage = APP_CONSTANT.VALIDATION;
  maxTrucks = AppConst.MAX_TRUCKS
  todayDate: any = moment();
  paymentModeArray: any = [
    { type: 'Online', value: 1 },
    { type: 'Offline', value: 2 }
  ]
  paymentDurationArray: any = [
    { type: '1 Month', value: 1 },
    { type: '3 Months', value: 3 },
    { type: '1 Year', value: 12 }
  ]
  paymentPlansArray = [
    { type: 'Starter', value: 'Starter' },
    { type: 'Business', value: 'Business' },
    { type: 'Premium', value: 'Premium' },
  ]
  currentUserData: any;
  constructor(public dialogRef: MatDialogRef<AddSubscriptionComponent>, private storage: LocalStorageProvider,
    @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog,
    private service: PagesService, private fb: FormBuilder,
    private loader: NgxUiLoaderService,
    private toastr: ToastrService,
    public validationService: ValidationService) { }



  ngOnInit(): void {
    this.updateClientForm = this.createForm();
    this.currentUserData = this.storage.getItem('opAvail');
    this.calEndDate(this.data.clientData?.subscription_data?.startDate, this.data.clientData?.subscription_data?.interval)
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.updateClientForm.patchValue({
        startDate: moment().format('yyyy-MM-DD')
      });
      this.getPackagesList();
    })
  }
  createForm() {
    return this.fb.group({
      package: ['', Validators.required],
      amount: ['', Validators.required],
      startDate: ['', Validators.required],
      paymentMode: ['', Validators.required],
      numberOfTrucks: ['', [Validators.max(this.maxTrucks)]],
      addOns: [{ value: [], disabled: true }]

    })
  }

  AddOnsArray = [
    { type: 'AI Routing', value: 'aiRouting' },
    { type: 'Email Marketing', value: 'emailMarketing' },
    { type: 'Notifications', value: 'notifications' },
    { type: 'AI Phone Agent', value: 'aiPhoneAgent' }
  ]

  setAddOns(event: any) {
    const selectedValues = event.value; // array of selected values
    console.log("Selected AddOns =", selectedValues);

    // If you want to do calculations, update prices, etc.
    this.calculateAddonPrice(selectedValues);
  }

  limitInput(event: any) {
    const value = event.target.value;

    // Allow empty
    if (!value) {
      this.calculateAddonPrice(this.updateClientForm.get('addOns').value);
      return;
    }

    // If typed number is outside 1–30, clear last typed char
    if (Number(value) < 1 || Number(value) > this.maxTrucks) {
      event.target.value = value.slice(0, -1);
    }
    this.updateClientForm.get('numberOfTrucks')?.setValue(event.target.value);

    // *** Recalculate amount whenever trucks change ***
    this.calculateAddonPrice(this.updateClientForm.get('addOns').value);
  }

  calculateAddonPrice(selectedAddons: string[] = []) {

    if (!this.selectedPackage) return;

    const pricing = this.selectedPackage.pricing;

    // Base price of the package
    let total = pricing.packagePrice;

    // Add AddOns
    selectedAddons.forEach(addon => {
      const priceKey = addon + "Price";  // example: aiRouting → aiRoutingPrice
      if (pricing[priceKey] !== undefined) {
        total += pricing[priceKey];
      }
    });

    // Also add trucks price if you want:
    const trucks = this.updateClientForm.get('numberOfTrucks')?.value || 0;
    if (trucks > 0) total += trucks * pricing.truckPrice;

    // Finally update the formControl
    this.updateClientForm.get('amount')?.setValue(Number(total).toFixed(2));
  }
  selectedPackage: any;
  packageList: any[] = [];
  getPackagesList() {
    this.loader.start();
    const payload = {
      page: 1,
      limit: 1000
    }
    this.service.get(payload, `${API_ROUTES.PACKAGES.packagesList}`).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.loader.stop();
          this.packageList = res.data.list.map(item => {
            return {
              _id: item._id,
              packageName: item.packageName,
              amount: item.amount,
              permissionId: item.permissionId,
              pricing: item?.pricing || []
            }
          });
          this.selectedPackage = this.packageList.find(item => item._id === this.updateClientForm.get('package').value);
        } else {
          this.loader.stop();
          this.toastr.error(res);
        }
      },
      error: (err: any) => {
        this.loader.stop();
        this.toastr.error(err.msg);
      }
    })
  }
  isAmountZero: boolean = false;
  setAmount(event) {
    this.selectedPackage = this.packageList.find(item => item._id === event.value);
    const addOnsControl = this.updateClientForm.get('addOns');
    if (this.selectedPackage.amount == 0) {
      this.payment.writeValue(2);
      this.isAmountZero = true;
      this.updateClientForm.patchValue({
        paymentMode: 2
      })
    } else {
      this.isAmountZero = false;
    }
    let total = this.selectedPackage.pricing.packagePrice;
    const trucks = this.updateClientForm.get('numberOfTrucks')?.value || 0;
    if (trucks > 0) total += trucks * this.selectedPackage.pricing.truckPrice;
    this.updateClientForm.patchValue({
      amount: Number(total).toFixed(2)
    })
    addOnsControl?.enable();
    this.updateClientForm.get('amount').disable();
  }

  @ViewChild('payment') payment: MatSelect;
  isOnline(event: any) {
    console.log("🚀 ~ AddClientDialogsComponent ~ isOnline ~ event:", event)
    if (event.value == 1 && !this.currentUserData) {
      const dialogRef = this.dialog.open(ComingSoonDialogComponent, {
        maxHeight: '100vh',
        width: '500px',
        disableClose: true,
        data: {

        }
        // data: {
        //   heading: "Add New Client",
        // }
      });
      dialogRef.afterClosed().subscribe((confirm: any) => {
        this.payment.writeValue(2);
        this.updateClientForm.patchValue({
          paymentMode: 2
        })
        // console.log(this.updateClientForm.value);
      });
    }
    if (this.isAmountZero) {
      this.payment.writeValue(2);
      this.updateClientForm.patchValue({
        paymentMode: 2
      })
    }
  }


  setTodecimal(): any {
    if (this.updateClientForm.value.amount) {
      this.updateClientForm.patchValue({ amount: Number(this.updateClientForm.value.amount).toFixed(2) })
    }
  }

  calEndDate(startDate, duration) {
    this.todayDate = moment();
    if (startDate && duration) {
      this.todayDate = moment(startDate).add(duration.length, duration.unit).add(1, 'day');
      if (this.todayDate.diff(moment(), 'day') < 0) {
        this.todayDate = moment();
      }
    }
  }


  addClient() {
    this.submitted = true;
    if (this.updateClientForm.valid) {
      let selectedPackage = this.packageList.find(item => item._id === this.updateClientForm.value.package);
      const addOnsToSend = {
        aiRouting: this.updateClientForm.value?.addOns?.includes("aiRouting") ?? false,
        emailMarketing: this.updateClientForm.value?.addOns?.includes("emailMarketing") ?? false,
        notifications: this.updateClientForm.value?.addOns?.includes("notifications") ?? false,
        aiPhoneAgent: this.updateClientForm.value?.addOns?.includes("aiPhoneAgent") ?? false
      }
      const formData = this.updateClientForm.getRawValue();
      let data = {
        paymentMode: this.updateClientForm.value.paymentMode,
        amount: Number(formData.amount).toFixed(2),
        packageId: this.updateClientForm.value.package,
        startDate: moment(this.updateClientForm.value.startDate).format('yyyy-MM-DD'),
        companyId: this.data.clientData.companyId,
        packageName: selectedPackage.packageName,
        permissionId: selectedPackage.permissionId,
        numberOfTrucks: this.updateClientForm.value.numberOfTrucks,
        addOns: addOnsToSend
      }
      if (data.paymentMode == 1) {
        this.openOnlinePaymentOption(data)
      }
      else {
        this.openOfflinePaymentOption(data)
      }
    }
  }

  openOfflinePaymentOption(data: any) {
    const dialogRef = this.dialog.open(ChoosePaymentComponent, {
      maxHeight: '450px',
      width: '700px',
      maxWidth: '100%',
      panelClass: 'choose-modalbox',
      disableClose: true,
      data: {
        heading: 'Choose mode of payment',
        isOnline: false,
        clientData: data
      }
    })
    dialogRef.afterClosed().subscribe((confirm: any) => {
      if (confirm !== undefined && confirm !== null && confirm) {
        data = { ...data, ...confirm }
        this.updateSubscription(data)
      }
    });
  }

  openOnlinePaymentOption(data: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxHeight: '100vh',
      width: '500px',
      disableClose: true,
      data: {
        title: `${APP_CONSTANT.CLIENT.ONLINE.title}`,
        sayYes: `${APP_CONSTANT.CLIENT.ONLINE.sayYes}`,
        sayNo: this.data.type == 'update' ? 'Create Subscription' : `${APP_CONSTANT.CLIENT.ONLINE.sayNo}`,
        img: ``,
        type: this.data.type
      }
    });
    dialogRef.afterClosed().subscribe((confirm: any) => {
      if (confirm !== undefined && confirm !== null && confirm) {
        this.openOnlinePaymentPopup(data)
      }
      else {
        if (this.data.type !== 'update') {
          this.updateSubscription(data)
        } else {
          data['isPayLater'] = true;
          this.updateSubscription(data);
        }
      }
    });
  }

  openOnlinePaymentPopup(data) {
    const dialogRef = this.dialog.open(OnlinePaymentComponent, {
      maxHeight: '100vh',
      width: '700px',
      maxWidth: '100%',
      disableClose: true,
      data: {
        clientData: data,
        type: this.data.type
      }
    });
    dialogRef.afterClosed().subscribe((confirm: any) => {
      if (confirm !== undefined && confirm !== null && confirm) {
        data = { ...data, ...confirm }
        this.updateSubscription(data)
      }
    });
  }

  updateSubscription(data: any) {
    if (data.payeeDetails && data.paymentMethod === 3) {
      const [year, month] = data.payeeDetails.expirationDate.split('-');
      const formattedDate = `${month}${year.slice(2)}`;
      data.payeeDetails.expirationDate = formattedDate;
    }
    data.duration = 1;
    this.loader.start();
    this.service.post(data, `${API_ROUTES.CLIENT.createSubscription}`).pipe().subscribe((response: any) => {
      if (response.status) {
        this.toastr.success(response.msg);
        this.close(true);
        if (data.payeeDetails) {
          const dialogRef = this.dialog.open(PaymentCompletedComponent, {
            maxHeight: '100vh',
            width: '700px',
            maxWidth: '100%',
            disableClose: true,
          })
        }
      } else {
        this.toastr.error(response);
      }
      this.loader.stop()
    }, (err) => {
      this.toastr.error(err.msg);
      this.loader.stop()
    })
  }

  close(val) {
    this.dialogRef.close(val);
  }


  get f() {
    return this.updateClientForm.controls;
  }

}
